var exports = {
  "a": "Box__qKDf6m",
  "E": "Text__JkXRpF",
};

module.exports = exports;
